module.exports = __webpack_public_path__ + "static/media/Slide03.b710a688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide03.png
// module id = 1625
// module chunks = 0